import { render, staticRenderFns } from "./Registereh.vue?vue&type=template&id=210ecd35&scoped=true&"
import script from "./Registereh.vue?vue&type=script&lang=js&"
export * from "./Registereh.vue?vue&type=script&lang=js&"
import style0 from "./Registereh.vue?vue&type=style&index=0&id=210ecd35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ecd35",
  null
  
)

export default component.exports